import axiosDmsInstance from './axiosDmsInstance';
import { handleApiError } from '../../common/util';
import { IStockUnitDetails } from '../../models/dms/stockUnit.model';

export const getStockUnitDetails = async (stockNumber: number) => {
  try {
    const url = `/api/stock/vehicle/v1/${stockNumber}/detail`;
    let params = {} as any;

    const response = await axiosDmsInstance.get<IStockUnitDetails>(`${url}`, {
      params,
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('getStockUnitDetails', err);
  }
};
